import { Phone, Sparkles, Users } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const detectExpansionOpportunityAccountGrowthCallAr: TemplateAr = {
  name: 'رصد فرص التوسع + مكالمة تنمية الحساب',
  description:
    'الذكاء الاصطناعي يرصد العملاء الجاهزين لتوسيع استخدامهم ويطلق مكالمات تنمية الحساب بعروض توسع.',
  category: 'ذكاء الإيرادات',
  workflow: [
    { icon: Users, label: 'نمو الاستخدام' },
    { icon: Sparkles, label: 'رصد ذكي' },
    { icon: Phone, label: 'مكالمة توسع', final: true },
  ],
  detailDescription: {
    paragraph1:
      'ارصد فرصة التوسع داخل حساباتك الحالية، وافتح محادثة النمو في وقتها. الـ AI يراقب الاستخدام اللي يقترب من الحد، وإشارات نمو الفريق، وطلبات المزايا المتقدمة، وأنماط التفاعل الإيجابي. ولمّا تقوى إشارات التوسع، يجدول مكالمة لمدير الحساب وعرض التوسع مخصص ومعه.',
    paragraph2:
      'الـ AI يكتب فرص التوسع ونتائج المكالمات في الـ CRM وأدوات عمليات الإيرادات عندك. ويحسب الإيراد المحتمل من كل فرصة، ويرتّبها لك حسب القيمة. والتوسع اللي ينجح يشغّل تحديث الفوترة ومسارات التهيئة تلقائياً.',
  },
  benefits: [
    'فرص التوسع تطلع لك تلقائياً',
    'إيراد الحساب يتضاعف ٢-٥ أضعاف',
    'تتحرّك وزخم الاستخدام في ذروته',
    'كل حساب يجيه عرض توسع على مقاسه',
    'العبء ينزل عن مدراء حساباتك',
    'تشوف معدل نجاح التوسع وتحسّنه',
  ],
};
